import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {StorageService} from '../../services/storage.service';
import {AlertService} from '../../services/alert.service';
import {AlertController, LoadingController} from '@ionic/angular';
import {environment} from '../../../environments/environment';
import { AuthService } from 'src/app/guards/auth.service';
import { BaseComponent } from 'src/app/base/base.component';
import { BidService } from 'src/app/services/bid.service';
import { PagesToNavigateService } from 'src/app/base/pages.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.page.html',
  styleUrls: ['./login.page.scss'],
})
export class LoginPage extends BaseComponent implements OnInit {

  credentials: FormGroup;
  version = environment.version;

  constructor(
    private fb: FormBuilder,
    private alertService: AlertService,
    protected loadingCtrl: LoadingController,
    protected router: Router,
    protected storageService: StorageService,
    protected alertController: AlertController,
    protected authService: AuthService,
    protected bidService: BidService,
    protected pagesToNavigateService: PagesToNavigateService,
  ) {
    super(loadingCtrl, router, storageService, alertController, authService, pagesToNavigateService);
  }

  get email() {
    return this.credentials.get('email');
  }

  get password() {
    return this.credentials.get('password');
  }

  ngOnInit() {
    this.authService.logout();
    this.credentials = this.fb.group({
      email: ['', [Validators.required]],
    });

    this.credentials.get('email').valueChanges.subscribe((event) => {
      this.credentials.get('email').setValue(event.toUpperCase(), {emitEvent: false});
    });
  }

  login(): void {
    this.showLoading()

    this.authService.startSession(this.credentials.value.email).subscribe(isLogged => {
      this.closeLoader();
      if (isLogged === true) {
        this.getGeneralConfig()
      } else {
        this.alertService.presentToast('danger', 'Usuario no enrolado');
      }
    }, _ => {
      this.closeLoader();
      this.alertService.presentToast('danger', 'Usuario no válido , el rfc no se encuentra en nuestros registros');
    });
  }

  enroll() {
    this.storageService.saveToStorage('type', 'register');
    this.router.navigate(['register-user']);
  }

  private getGeneralConfig() {
    this.bidService.config().subscribe((permissions: any []) => {
      this.closeLoader();
      const searchPermission = permissions.filter(config => config.parameter === 'Busqueda');
      if(searchPermission) {
        console.log("Is permission to search: "+ searchPermission[0].value)
        this.pagesToNavigateService.pages$.next(this.buildMenu(searchPermission[0].value));
      }

      this.router.navigate(['/login-desktop', { email: this.credentials.value.email }]);

    }, _ => {
      this.closeLoader();
      this.alertService.presentToast('danger', 'Usuario no válido , el rfc no se encuentra en nuestros registros');
    });
  }
}
